'use client'

import { useLiveVenuePayloads } from '@/service/venue-health.hook'
import { createMultiStreamHook, createStreamHook } from '@/service/ws/use-web-socket-with-proto'
import { ChartData, ChartDataStream } from '@/types/generated/public_api'

const useRawChartStream = createStreamHook<ChartDataStream, ChartData>({
  channelKey: 'chartDataStream',
  extractResponse: (message) => message.data?.chartData,
  getPayloadDeps: (p) => [p.symbol, p.exchange, p.timeframe],
  listenerChannelKey: 'chartDataStream',
})

const useRawChartStreams = createMultiStreamHook<ChartDataStream, ChartData>({
  channelKey: 'chartDataStream',
  extractResponse: (message, payloads) => {
    const chartData = message.data?.chartData
    if (!chartData) return undefined
    return payloads.some(
      (payload) =>
        payload.symbol === chartData.symbol &&
        payload.exchange === chartData.exchange &&
        payload.timeframe === chartData.timeframe
    )
      ? chartData
      : undefined
  },
  listenerChannelKey: 'chartDataStream',
})

export function useChartStream(options: Parameters<typeof useRawChartStream>[0]) {
  const connected = options.connected ?? true
  const payloads = useLiveVenuePayloads([options.payload], connected)
  return useRawChartStream({
    ...options,
    connected: payloads.length > 0,
  })
}

export function useChartStreams(options: Parameters<typeof useRawChartStreams>[0]) {
  const connected = options.connected ?? true
  const payloads = useLiveVenuePayloads(options.payloads, connected)
  return useRawChartStreams({
    ...options,
    connected: payloads.length > 0,
    payloads,
  })
}
